/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat, Gianni Guida.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/forum/extend';
import app from 'flarum/forum/app';
import Navigation from 'flarum/common/components/Navigation';

export default function () {
	extend(Navigation.prototype, 'view', function (vnode) {
		const { history } = app;

		let buttons = [this.getDrawerButton()];

		if (history.canGoBack()) {
			buttons = [...buttons, this.getBackButton(), this.getPaneButton()];
		}
		buttons = buttons.filter((item) => !!item);
		vnode.children = buttons;
	});
}
